import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingConstants, OrderingOperations, OrderingSelectors } from 'polygon-ordering';

import debug from '../utils/debug';

import { RootState } from 'store';
import alertForValidation, { customerConfirm } from '../utils/alertForFailedValidation';
import { DeliveryAddressDto } from '../libs/polygon-ordering/src/dtos/DeliveryAddressDto';

const { validateOrder, updateKeyOrderProperty } = OrderingOperations;
const { getSaleType, getMember } = OrderingSelectors;

const { DELIVERY_SALE_TYPES } = OrderingConstants;

export const validate = createAsyncThunk(
  'validate',
  async (_data: undefined, { dispatch, getState, rejectWithValue }) => {
    debug('validate');

    let proceedToFinalise = true;

    try {
      const saleType = getSaleType(getState() as RootState);
      const memberPresent = Boolean(getMember(getState() as RootState));
      const effectiveDeliveryAddress = (getState() as RootState).desiredDeliveryAddress;

      const deliveryAddressString = DeliveryAddressDto.toShortAddressString(effectiveDeliveryAddress);

      const { valid, errorText, reason } = await dispatch(
        validateOrder({
          authenticationMethod: memberPresent ? 'member' : 'none',
          deliveryDropOffCoordinates: effectiveDeliveryAddress?.deliveryDropOffCoordinates,
          customAddress: deliveryAddressString,
          customSuburb: effectiveDeliveryAddress?.addressComponents?.suburb,
          customPostCode: effectiveDeliveryAddress?.addressComponents?.postCode,
        }),
      ).unwrap();

      if (!valid) {
        if (DELIVERY_SALE_TYPES.includes(saleType)) {
          alertForValidation(reason!, errorText);
        } else {
          await dispatch(updateKeyOrderProperty({ autoApply: true, updateDeliveryEstimate: true }));

          const secondValidation = await dispatch(
            validateOrder({
              authenticationMethod: memberPresent ? 'member' : 'none',
              deliveryDropOffCoordinates: effectiveDeliveryAddress?.deliveryDropOffCoordinates,
              customAddress: deliveryAddressString,
              customSuburb: effectiveDeliveryAddress?.addressComponents?.suburb,
              customPostCode: effectiveDeliveryAddress?.addressComponents?.postCode,
            }),
          ).unwrap();

          if (!secondValidation.valid) {
            alertForValidation(secondValidation.reason!, secondValidation.errorText);
          } else {
            customerConfirm();
          }
        }

        proceedToFinalise = false;
      }

      return {
        proceedToFinalise,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
